<template>
  <div
    id="minimalMike"
    @click="toggle_microphone"
    :class="recognition_on ? 'is_on': 'is_off'"
  >
    <microphone-icon
      :size="size"
      :is_on="recognition_on"
    ></microphone-icon>
  </div>
</template>

<script>
    import store from '../store';
    import {mapState} from 'vuex';
    import MicrophoneIcon from './MicrophoneIcon';
    import {EventBus} from "./EventBus";
    // instead of getting the state via computed directly


    let SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    let recognition = SpeechRecognition ? new SpeechRecognition() : false;
    //recognition.continuous = true;
    try {
        if (recognition && recognition.continuous) {
            recognition.continuous = false;
        }
    } catch (e) {
        console.warn("failed to set recognition continuous")
    }

    export default {
        name: "minimalMike",
        components: {MicrophoneIcon},
        data() {
            return {
                listening: false,
                event_log: [],
                sentences: [],
            }
        },
        store,
        props: {
            listen_for_input: Boolean,
            is_disabled: {},
            size: {default: 24},
            lang: {default: 'de-DE'}

        },
        watch: {
            listen_for_input: function (newState) {
                let log_msg = "DEBUG: Listening State changed.  New state is: " + newState;
                this.event_log.push(log_msg);
                console.log(log_msg)
                if (this.listen_for_input) {
                    // this.startSpeechRecognition();
                    if (this.is_disabled){
                        console.log("LISTEN FOR INPUT CHANGED: Start Speech attempted but microphone is disabled.")
                        this.$store.dispatch('recognition_off');
                    } else {
                        this.$store.dispatch('recognition_on')
                    }
                } else {
                    this.$store.dispatch('recognition_off');
                }
            },
            recognition_on: function (is_on) {
                if (is_on) {
                    // alert('starting speech recognition now');
                    if (this.is_disabled){
                        console.log("Start Speech attempted but microphone is disabled.")
                        this.$store.dispatch('recognition_off');

                    } else {
                        this.startSpeechRecognition();
                    }
                } else {
                    // alert('Ending speech recognition now');
                    this.endSpeechRecognition();
                }
            },
            lang: function (new_lang) {
                this.recognition.lang = new_lang;
            }
        },
        computed: mapState(['recognition_on', 'recognition_disabled']),
        created() {
            EventBus.$on('stop_listening', event_data => {
                console.log(`MINIMAL MIKE - EVENT-BUS: stop_listening event`);
                console.dir(event_data);
            });
            EventBus.$on('start_listening', event_data => {
                console.log(`MINIMAL MIKE - EVENT-BUS: start_listening event`);
                console.dir(event_data);
            });
        },
        methods: {
            toggle_microphone() {
                if (!this.recognition_on && !this.is_disabled) {
                    //alert(`toggled with is_disabled set to: ${this.is_disabled}`);
                    store.dispatch('recognition_enabled')
                    store.dispatch('recognition_on');

                } else {
                    this.$store.dispatch('recognition_disabled');
                    store.dispatch('recognition_disabled');
                    this.$store.dispatch('recognition_off');
                    store.dispatch('recognition_off');
                }
            },
            stop_listening: function () {
                this.listening = false;
                this.$store.dispatch('recognition_off');
                // this.log_msg("Emitting update:listening event - with false");
                // this.$root.$emit('update-listening', false);
                // this.$emit('update-listening', false);
                // this.endSpeechRecognition();
            }
            ,
            start_listening: function () {
                // this.log_msg("Emitting update:listening event - with true");
                // this.$root.$emit('update-listening', true);
                //this.$emit('update-listening', true);
                this.$store.dispatch('recognition_on');
                //this.startSpeechRecognition();
            }
            ,

            // Speech listeners
            startSpeechRecognition() {
                //this.pause_audio_sources();
                this.log_msg("method: startSpeechRecognition called");
                const rec_disabled = this.$store.state.recognition_disabled;
                const rec_not_on = !this.$store.state.recognition_on;
                const lis_not_on = !this.$store.state.listening_on;
                const mik_not_on = !this.$store.state.microphone_on;
                if (rec_disabled ||
                    rec_not_on
                ) {
                    this.log_msg("Start Recognition called, but recognition is not on");
                    console.log(`rec_disabled: ${rec_disabled}`);
                    console.log(`rec_not_on: ${rec_not_on}`);
                    console.log(`lis_not_on: ${lis_not_on}`);
                    console.log(`mik_not_on: ${mik_not_on}`);
                    return;
                }
                if (this.listening) {
                    this.log_msg("Start Recognition called, but we are already listening");
                    return;
                } else {
                    this.log_msg("startSpeechRecognition: Listening Flag set to True");
                    this.listening = true;
                }
                if (!recognition) {
                    this.error = 'Speech Recognition is not available on this browser. Please use Chrome or Firefox';
                    return;
                } else {
                    this.log_msg("STARTING REKOGNITION...123");
                }
                // PAUSE ALL AUDIO SOURCES ON PAGE!
                recognition.lang = this.lang;
                recognition.interimResults = true;
                //recognition.continuous = true;
                recognition.onresult = this.onSpeechResultHandler;
                recognition.onend = this.onRecognitionEndHandler;
                recognition.onspeechend = this.onSpeechEndHandler;
                recognition.onspeechstart = this.onSpeechStartHandler;

                recognition.start();
                this.log_msg("method: startSpeechRecognition: recognition.start() called");
                this.$root.$emit('update:listening', true);
                this.log_msg("method: startSpeechRecognition: pushed $root.$emit event 'update:listening' to true");
            }
            ,
            endSpeechRecognition() {
                recognition.stop();
                this.log_msg("method: endSpeechRecognition called");
                this.$emit('update:speech_result', {
                    sentences: this.sentences
                });
                this.log_msg("method: endSpeechRecognition emitted 'speechend' event with sentences: ", this.sentences);
            }
            ,

            capitalizeFirstLetter(string) {
                if (string && string.length) {
                    return string.charAt(0).toUpperCase() + string.slice(1)
                }
            }
            ,
            // Handlers for Speech Recognition Events
            onSpeechStartHandler(event) {
                this.listening = true;
                this.log_msg("Event - speechstart handler: ");
                this.log_msg('Speech has been detected');
                console.dir(event);
            }
            ,
            onSpeechEndHandler(event) {
                this.listening = false;
                this.log_msg('Speech has stopped being detected');
                let silence_elapsed = (new Date()) - this.silence_started;
                this.log_msg("Event - speechend handler");
                this.log_msg("Event Type :", typeof (event));
                console.dir({
                    sentences_length: this.sentences ? this.sentences.length : null,
                    interim_result: this.interim_result,
                    sentences: this.sentences,
                    silence_elapsed: silence_elapsed

                });
                recognition.stop();
                this.$root.$emit('update-listening', false);
                this.event_log.push("method: onSpeechEndHandler: pushed $root.$emit event 'update:listening' to true");

            }
            ,
            onSpeechResultHandler(event) {
                //Reset silence on each result
                //    recognition.start();
                this.silence_started = new Date();
                let results = event.results ? event.results : null;
                console.log("Event - speechresult handler");
                let isFinal = results ? results[0].isFinal : false;
                this.log_msg(`Result is final?  isFinal: ${isFinal}`);
                let transcript = event.results[0][0].transcript;
                this.log_msg(`Transcript ([0][0]):  ${transcript}`);
                if (isFinal) {
                    let my_utterance = this.capitalizeFirstLetter(transcript);
                    this.sentences.push(my_utterance);
                    this.$emit('microphone_input', my_utterance);
                    this.log_msg("Got a final result, so setting listening to false");
                    this.log_msg(`FINAL RESULT:  ${my_utterance} `);
                    this.log_msg(`SENTENCES:  ${this.sentences.join("\n")} `);
                } else {
                    this.interim_result = transcript;
                    this.$emit('microphone_interim_data', this.interim_result);
                    this.log_msg(`Interim Result: ${this.interim_result}`);
                }
            }
            ,
            onRecognitionEndHandler(event) {
                // alert("RECOGNITION END");
                this.$store.dispatch('recognition_off');
                if (this.listening) {
                    this.listening = false;
                    let msg = "minimalMike: Set listening to false in onRecognitionEnd Handler";
                    console.warn(msg);
                    // alert(msg);
                }
                this.log_msg('onRecognitionEndHandler: listening set to FALSE now (recognition ended)');
                this.log_msg("Event - Recognition end: ");
                this.log_msg('Speech recognition service disconnected');
                console.log(event);
                let silence_elapsed = 0;
                if (this.silence_started) {
                    silence_elapsed = (new Date()) - this.silence_started;
                    this.log_msg(`Silence Elapsed (on Recognition End) ${silence_elapsed}`);
                }
                if (silence_elapsed > 1000) {
                    this.log_msg(`Recognition Ended after ${silence_elapsed}`);
                    //this.startSpeechRecognition();
                }
            }
            ,
            log_msg: function (msg) {
                if (msg && msg.length) {
                    this.event_log.push(msg);
                    console.log(msg);
                    return;
                } else {
                    return;
                }
            }
            ,
            pause_audio_sources: function () {
                //const audio_players = document.getElementsByTagName('audio');
                const audio_players = document.querySelectorAll('audio');
                audio_players.forEach(async (player) => {
                    if (player.pause && typeof player.pause === 'function') {
                        await player.pause()
                    }
                });
                //const iframes =  document.getElementsByTagName('iframe');
                const iframes = document.querySelectorAll('iframe');
                let Vimeo = window.Vimeo || {};
                iframes.forEach(async (iframe) => {
                    if (iframe.src && iframe.src.match(/^https:\/\/player\.vimeo\.com/i)) {
                        let player = new Vimeo.Player(iframe);
                        await player.pause();
                    }
                });
            }
        }
    }
</script>
<style scoped>
#minimalMike {
  border-radius: 50%;
  padding: 3px;
  height: 4.5rem;
  width: 4.5rem;
}
  #minimalMike.is_on {
    background-color: lime;
  }

  #minimalMike.is_off {
    background-color: pink;
    background-color: WhiteSmoke;
  }


</style>
